import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_ADD_IN_CURRENT_USER_PATH = '/outlook_add_in/current_user';

export type OutlookCurrentUserJson = {
  current_user: {
    id: number;
    name: string | null;
    email: string | null;
    first_agency: {id: number; name: string} | null;
    email_accounts: Array<{
      id: number;
      email_address: string;
      provider: string | null;
    }>;
  };
};

export const fetchOutlookCurrentUser = async (
  request: PodRequestFn,
  init?: RequestInit
): Promise<OutlookCurrentUserJson> => {
  const response = await request(OUTLOOK_ADD_IN_CURRENT_USER_PATH, init);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookCurrentUserJson;
};
